import {
    API
} from '../Api.class';

export class InventoryTypesAPI extends API {

    constructor(baseUrl) {
        super(baseUrl)

    }


    async list(pagination, filter, meta) {
        this.loading = true

        return await this.__axiosInstance.get('api/v1/inventory/types', {
            meta,
            params: {
                ...pagination,
                ...filter
            }
        })
    }

    async get(id, meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/inventory/types/${id}`, {
            meta
        });

    }

    async create(body, meta) {
        this.loading = true;

        return await this.__axiosInstance.post('api/v1/inventory/types', body, {
            meta
        });
    }
    async update(creative, meta) {
        this.loading = true

        return await this.__axiosInstance.put(`api/v1/inventory/types/${creative.id}`, creative, {
            meta
        });
    }

    async delete(creative, meta) {
        this.loading = true

        return await this.__axiosInstance.delete(`api/v1/inventory/types/${creative.id}`, {
            meta
        });
    }
}